"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const flat_ejs_1 = require("./flat.ejs");
const form_ejs_1 = require("./form.ejs");
exports.default = { flat: flat_ejs_1.default, form: form_ejs_1.default };
